import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MapAllowedIcao, CreateMapAllowedIcaoResponse, RemoveMapAllowedIcaoResponse, IcaoSupportStatus } from '../models/map-allowed-icao';

@Injectable()
export class MapAllowedIcaosService {
    private headers: HttpHeaders;
    private accessPointUrl: string;

    constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this.headers = new HttpHeaders({
            'Content-Type': 'application/json; charset=utf-8',
        });
        this.accessPointUrl = baseUrl + 'api/mapallowedicaos';
    }

    public getAll(): Observable<MapAllowedIcao[]> {
        return this.http.get<MapAllowedIcao[]>(this.accessPointUrl, {
            headers: this.headers,
        });
    }

    public checkSupport(icaos?: string): Observable<IcaoSupportStatus[]> {
        let url = `${this.accessPointUrl}/CheckSupport`;
        if (icaos) {
            url += `?icaos=${encodeURIComponent(icaos)}`;
        }
        return this.http.get<IcaoSupportStatus[]>(url, {
            headers: this.headers,
        });
    }

    public create(icaos: string): Observable<CreateMapAllowedIcaoResponse> {
        return this.http.get<CreateMapAllowedIcaoResponse>(
            `${this.accessPointUrl}/Create?icaos=${encodeURIComponent(icaos)}`,
            { headers: this.headers }
        );
    }

    public remove(icaos: string): Observable<RemoveMapAllowedIcaoResponse> {
        return this.http.get<RemoveMapAllowedIcaoResponse>(
            `${this.accessPointUrl}/Remove?icaos=${encodeURIComponent(icaos)}`,
            { headers: this.headers }
        );
    }
}

